export default __webpack_public_path__ + "static/media/Energy Shield.d656799f.png";